import { render } from "./RichSectionEditor.vue?vue&type=template&id=aca36932&scoped=true"
import script from "./RichSectionEditor.vue?vue&type=script&lang=js"
export * from "./RichSectionEditor.vue?vue&type=script&lang=js"

import "./RichSectionEditor.vue?vue&type=style&index=0&id=aca36932&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca36932"]])

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QEditor});
